import { createIcon } from './Icon'

// Do not modify this file as it was auto-generated by update-icons.mjs
export default createIcon(
  'CloseIcon',
  'close',
  'M245.509 790.631c-21.025 21.025-55.114 21.025-76.14 0s-21.025-55.115 0-76.14l266.491-266.491-266.491-266.491c-21.025-21.028-21.025-55.117 0-76.14 21.026-21.028 55.115-21.028 76.14 0l266.491 266.491 266.491-266.491c21.023-21.023 55.112-21.023 76.14 0 21.023 21.028 21.023 55.117 0 76.14l-266.491 266.491 266.491 266.49c21.023 21.026 21.023 55.115 0 76.14-21.028 21.026-55.117 21.026-76.14 0l-266.491-266.49-266.491 266.491z',
)
